import React from 'react';
import { connect } from 'react-redux';
import styles from './experience.module.scss';
import { Helmet } from 'react-helmet';

const Experience = ({showHelmet = true, words}) => {
    const items = [
        {
            period: words.from2021,
            points: [words.from2021Info1]
        },
        {
            period: words.from2019,
            points: [words.from2019Info1, words.from2019Info2, words.from2019Info3, words.from2019Info4]
        },
        {
            period: words.from2017,
            points: [words.from2017Info1, words.from2017Info2]
        }
    ];

    return(
        <>
            {showHelmet && <Helmet>
                <meta 
                    name="keywords" 
                    content="Experience, work"
                />
                <meta
                    name="description"
                    content="Experience of Arman Gharibyan"
                />
                <title>{words.experienceTitle}</title>
            </Helmet>}
            <section className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.kicker}>{words.experience}</div>
                    <h2 className={styles.title}>{words.experienceTitle}</h2>
                </div>
                <div className={styles.timeline}>
                    {items.map((item) => (
                        <article key={item.period} className={styles.item}>
                            <div className={styles.time}>{item.period}</div>
                            <ul className={styles.points}>
                                {item.points.map((point) => (
                                    <li key={point}>{point}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>
        </>
        
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(Experience)